import $ from 'jquery';

export const init = () => {
	if (window.location.hash !== '') {
		$('html, body').animate({
			scrollTop: $(window.location.hash).offset().top - $('.b-content').outerHeight(),
		}, 200);

		$(window.location.hash).find('.b-calendar-item').addClass('is-active');
	}

	$(document)
		.on('click', '.b-calendar__link.is-active, .tooltip__link', function(e) {
			var $dest = $(this.hash);

			if ($dest) {
				$('html, body').animate({
					scrollTop: $dest.offset().top - $('.b-content').outerHeight(),
				}, 200);

				$('.b-calendar-item.is-active').removeClass('is-active');
				$dest.find('.b-calendar-item').addClass('is-active');
			}
		})
		.on('change', '.calendar-redirect', function(e) {
			calendar_reload( $(this).val() );
		})
		.on('click', '.calendar-redirect-link', function(e) {
			calendar_reload( $(this).attr('href') );
			e.preventDefault();
		});

	function calendar_reload( link ) {
		window.history.pushState(
			{ page: 'Kalendář'  },
			document.title,
			link,
		);

		var link = skwp.calendar_api_url + '/' + link;

		if ( !$('body').hasClass('page-homepage') && !$('body').hasClass('page-homepage-sub') ) {
			link = link + '&with_events=true';
		}

		if ( $('body').hasClass('page-homepage') || $('body').hasClass('page-homepage-sub') ) {
			link = link + '&homepage_ajax=true';
		}

		$.get( link, function( data ) {
			if ( typeof data.dates != 'undefined' && typeof data.events != 'undefined' ) {
				$('#calendar-dates').replaceWith( data.dates );

				if ( data.events != '' ) {
					$('#calendar-events').replaceWith( data.events );
				}

				// sticky - fix
				$( window ).trigger( 'resize' );

				window.setTimeout( function() {
					window.scrollTo( 0, $( window ).scrollTop() + 1 );
				}, 50 );
			}
		} );
	}
};



// WEBPACK FOOTER //
// ./src/js/components/calendar.js